module.exports = __webpack_public_path__ + "img/2_205.0e47a384.png";